import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=25b772d4&"
import script from "./Dashboard/Dashboard.js?vue&type=script&lang=js&"
export * from "./Dashboard/Dashboard.js?vue&type=script&lang=js&"
import style0 from "./Dashboard/Dashboard.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports